import React from "react";
import { RouteItem } from "./route-item";
import { Link } from "@reach/router";
import { Text } from "@chakra-ui/react";

export const Contribute = () => (
  <RouteItem title="Contribute Data">
    <Text>
      The University of Idaho Library welcomes submissions of data to enhance
      this collection. Please contact us if you wish to contribute data.
    </Text>
  </RouteItem>
);
